import ConstructImage from '../../../assets/images/construct.png';
import styles from './bidError.module.scss';
import { useTranslation, Trans } from 'react-i18next';
import AccuratorLogo from '../../../assets/svg/weblogo.svg';

const QuotationError = ({ error }: { error?: string }) => {
  const [t] = useTranslation('quotation', { keyPrefix: 'quoteError' });
  return (
    <div className={styles.container}>
      <div className={styles.subContainer}>
        <img src={ConstructImage} alt={t('imageAlt.construct', 'Error')} />
        <div>
          <p>{t('heading', 'Något gick fel')}</p>
          <p>{error}</p>
        </div>
      </div>
      <div className={styles.footer}>
        <img src={AccuratorLogo} style={{ height: '40px' }} alt={t('imageAlt.logo', 'Accurator Logo')} />
        <p><Trans t={t} i18nKey="footer" components={{a: <a />}} /></p>
      </div>
    </div>
  );
};

export default QuotationError;
